import React from 'react'
// import data from 
import data from '../data/data.json'
const social = () => {
    const icons = data.icon
  return (
    <div className="home__social">
        {
            icons.map(({logo,name,link,id})=>{
                return(
                    <a href={link} className='home__social-icon' target="_blank" key={id}>
                        <i className={logo}></i>
                    </a>
                )
            })
        } 
    </div>
    )
}

export default social